<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-9">
        <div class="row">
          <h1>Profile</h1>
        </div>
        <div class="row align-items-center">
          <h2>Personal Information</h2>
          <div *ngIf="!isEditing" class="edit ml-auto" (click)="onEdit()">
            <button
              icon="edit"
              themeColor="primary"
              fillMode="outline"
              size="medium"
              data-id=""
              kendoButton
            ></button>
          </div>
          <div *ngIf="isEditing" class="save ml-auto" (click)="onSave()">
            <button themeColor="primary" size="medium" data-id="" kendoButton>
              Save Change
            </button>
          </div>
        </div>
        <div class="row personal">
          <div class="col-12 col-lg-12 ml-auto info">
            <form [formGroup]="userForm" [ngClass]="{ editing: isEditing }">
              <div class="row">
                <div class="field col-6 col-lg-4">
                  <label>First Name</label>
                  <input
                    type="text"
                    formControlName="firstName"
                    [readonly]="!isEditing"
                  />
                </div>
                <div class="field col-6 col-lg-4">
                  <label>Last Name</label>
                  <input
                    type="text"
                    formControlName="lastName"
                    [readonly]="!isEditing"
                  />
                </div>
                <div class="field col-6 col-lg-4">
                  <label>Account Role</label>
                  <input type="text" value="{{ role }}" readonly />
                </div>
                <div class="field col-6 col-lg-4">
                  <label>Email Address</label>
                  <input type="text" formControlName="email" readonly />
                </div>
                <div class="field col-6 col-lg-4">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    formControlName="phoneNumber"
                    [readonly]="!isEditing"
                  />
                </div>
                <div class="field col-6 col-lg-4">
                  <label>Joined</label>
                  <input
                    type="text"
                    value="{{ createdAt | date : 'longDate' }}"
                    readonly
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row change-password">
          <h2>Change Password</h2>
          <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">
            <div class="row">
              <div class="col-12 col-lg-3 old-password">
                <label>Old Password</label>
                <input
                  type="password"
                  placeholder="Old Password"
                  formControlName="oldPassword"
                />
                <div
                  class="errors"
                  [ngClass]="{
                    'has-errors':
                      !passwordForm.controls.oldPassword.valid &&
                      passwordForm.controls.oldPassword.touched
                  }"
                >
                  Your old password is required.
                </div>
              </div>
              <div class="col-12 col-lg-3 pass">
                <span>Password must contain:</span>
                <ul>
                  <li>At least 6 characters</li>
                  <li>At least 1 upper case letter</li>
                  <li>At least 1 number</li>
                  <li>
                    At least 1 special character ({{ specialCharacters }})
                  </li>
                </ul>
              </div>
              <div class="col-12 col-lg-3 new-password">
                <label>New Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  [pattern]="passRegex"
                  formControlName="newPassword"
                  minlength="6"
                />
                <div
                  class="errors"
                  [ngClass]="{
                    'has-errors':
                      passwordForm.controls.newPassword.touched &&
                      !passwordForm.controls.newPassword.valid
                  }"
                >
                  New password doesn't meet requirements.
                </div>
              </div>
              <div class="col-12 col-lg-3 confirm-password">
                <label>Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  [pattern]="passRegex"
                  formControlName="confirmNewPassword"
                />
                <div
                  class="errors"
                  [ngClass]="{
                    'has-errors':
                      !passwordForm.controls.confirmNewPassword.valid &&
                      passwordForm.controls.newPassword.valid &&
                      passwordForm.controls.newPassword.touched &&
                      passwordForm.controls.confirmNewPassword.dirty
                  }"
                >
                  Passwords do not match.
                </div>
                <button
                  type="submit"
                  themeColor="primary"
                  size="medium"
                  [disabled]="!passwordForm.valid"
                  data-id=""
                  kendoButton
                >
                  Change Password
                </button>
                <div class="updated">
                  <div class="circle">
                    <i class="k-icon k-font-icon k-i-check"></i>
                  </div>
                  Password Changed
                </div>
              </div>
            </div>
          </form>
        </div>
        <cyborg-error [error]="error"></cyborg-error>
      </div>
    </div>
  </div>
</section>

<cyborg-modal-avatar class="modal"></cyborg-modal-avatar>
